const MUTATION_TYPE = {
  setStatsStudentsToPartners: 'setStatsStudentsToPartners',
  setStatsClassesStudentsDistribution: 'setStatsClassesStudentsDistribution',
  setStatsOlympicsResults: 'setStatsOlympicsResults',
  setStatsCountSchoolsDOClasses: 'setStatsCountSchoolsDOClasses'
}

const ACTION_TYPE = {
  fetchStatsStudentsToPartners: 'fetchStatsStudentsToPartners',
  updateStatsStudentsToPartners: 'updateStatsStudentsToPartners',
  fetchStatsClassesStudentsDistribution: 'fetchStatsClassesStudentsDistribution',
  updateStatsClassesStudentsDistribution: 'updateStatsClassesStudentsDistribution',
  fetchStatsOlympicsResults: 'fetchStatsOlympicsResults',
  updateStatsOlympicsResults: 'updateStatsOlympicsResults',
  fetchStatsCountSchoolsDOClasses: 'fetchStatsCountSchoolsDOClasses',
  updateStatsCountSchoolsDOClasses: 'updateStatsCountSchoolsDOClasses'
}

const GETTER_TYPE = {
  getStatsStudentsToPartners: 'getStatsStudentsToPartners',
  getStatsClassesStudentsDistribution: 'getStatsClassesStudentsDistribution',
  getStatsOlympicsResults: 'getStatsOlympicsResults',
  getStatsCountSchoolsDOClasses: 'getStatsCountSchoolsDOClasses'
}

export {
  MUTATION_TYPE,
  ACTION_TYPE,
  GETTER_TYPE
}
